import { useTranslation } from 'react-i18next'
import { useMemo } from 'react'
import { LargePagination, SmallPagination } from './planning-pagination-elements.component'

interface Props {
  currentPage: number
  updatePageNumber: (page: number) => void
  patientMedEventsCount?: number
  totalPages?: number
}

export default function PlanningPagination({
  currentPage,
  updatePageNumber,
  patientMedEventsCount,
  totalPages,
}: Readonly<Props>) {
  const { t } = useTranslation()

  const Pagination = useMemo(() => {
    if (!totalPages) {
      return (
        <nav className="c-flex c-items-center c-gap-4">
          <div className="c-w-16 c-h-8 c-bg-grey-100 c-rounded c-animate-pulse"></div>
          <div className="c-flex c-items-center c-gap-1">
            {Array.from({ length: 3 }, (_, index) => (
              <div key={index} className="c-w-8 c-h-8 c-bg-grey-100 c-rounded-full c-animate-pulse"></div>
            ))}
          </div>
          <div className="c-w-16 c-h-8 c-bg-grey-100 c-rounded c-animate-pulse"></div>
        </nav>
      )
    }
    if (totalPages <= 7) {
      return (
        <SmallPagination currentPage={currentPage} totalPages={totalPages} onChangePage={updatePageNumber} />
      )
    }
    return (
      <LargePagination currentPage={currentPage} totalPages={totalPages} onChangePage={updatePageNumber} />
    )
  }, [updatePageNumber, currentPage, totalPages])

  if (patientMedEventsCount === 0) {
    return null
  }

  return (
    <div className="c-border-t c-border-grey-400 c-pt-2 c-flex c-justify-center">
      <div className="c-text-sm c-text-grey-600 c-absolute c-right-auto c-left-0">
        {t('pages.planning.pagination.patients-count', { patientCount: patientMedEventsCount || 0 })}
      </div>
      {Pagination}
    </div>
  )
}
